import { useEffect } from "react";

interface SeoOptions {
  title: string;
  description?: string;
  keywords?: string;
}

function setMeta(name: string, content: string) {
  let el = document.querySelector<HTMLMetaElement>(`meta[name="${name}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute("name", name);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

export function useSeo({ title, description, keywords }: SeoOptions) {
  useEffect(() => {
    document.title = title;
    if (description) setMeta("description", description);
    if (keywords) setMeta("keywords", keywords);
  }, [title, description, keywords]);
}

export default useSeo;